(function () {
  const SELECTOR = '[data-mhl-shipping-bar]';
  const MESSAGE_ACHIEVED = '送料無料でお届けいたします';

  const formatMoney = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme_money_format) {
      return Shopify.formatMoney(cents, window.theme_money_format);
    }
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  };

  const updateBar = (bar, totalPrice) => {
    const threshold = Number(bar.dataset.thresholdCents || 0);
    if (!threshold) return;
    const remaining = Math.max(threshold - totalPrice, 0);
    const percent = Math.min((totalPrice / threshold) * 100, 100);
    const achieved = remaining <= 0;

    bar.classList.toggle('mhl-shipping-bar--achieved', achieved);

    const message = bar.querySelector('.mhl-shipping-bar__message');
    const fill = bar.querySelector('.mhl-shipping-bar__progress-fill');
    if (fill) fill.style.width = percent + '%';
    if (message) {
      if (achieved) {
        message.textContent = MESSAGE_ACHIEVED;
      } else {
        message.innerHTML =
          'あと<span class="mhl-shipping-bar__amount">' +
          formatMoney(remaining) +
          '</span>で送料無料';
      }
    }
  };

  const updateAll = (totalPrice) => {
    document.querySelectorAll(SELECTOR).forEach((bar) => updateBar(bar, totalPrice));
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const data = event && event.cartData;
      if (!data || typeof data.total_price !== 'number') return;
      updateAll(data.total_price);
    });
  }
})();
